// Default search values for filtering carts
export const searchValues = {
  searchKey: "",
};

// Mapping of Excel header names to their corresponding field names in the data
export const excelHeaderCellsName = {
  "المعرف": "id",
  "اسم العميل": "userName",
  "رقم الجوال": "userPhone",
  "عنوان المشروع": "projectTitle",
  "التصنيف": "classificationName",
  "المبلغ المطلوب": "requiredAmount",
};
